import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';

export default function FeePopup({ callInstallation }: any) {
    return (
        <div className={`installation-popup ${css['installation-popup']}`}>
            <div className="installation-popup-content">
                <div className="installation-popup-header">
                    <svg
                        className="header-close"
                        onClick={callInstallation}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="installation-popup-body">
                    <p className="installation-title">
                        {
                            "Consult for installation service for your new purchase, and we'll reimburse you $500 from the total installation fee. This limited-time offer ensures your setup is as seamless and cost-effective as possible."
                        }
                    </p>
                    <p className="installation-desc">{'*For users who placed orders between 4.27-5.31, 2024.'}</p>
                    <ul className="lists">
                        <li className="list">Step 1: Purchase a Smart Home Panel 2 or any bundle that includes it.</li>
                        <li className="list">Step 2 : Choose our installation service/ Opt for a qualified electrician for Smart Home Panel 2 installation.</li>
                        <li className="list">
                            Step 3 : Contact the Customer service team to reimburse the fee with the following claims：
                            <ul className="list-subs">
                                <li className="list-sub">The invoice from the electrician detailing the installation service and cost.</li>
                                <li className="list-sub">SN number of DELTA Pro Ultra and Smart Home Panel 2</li>
                                <li className="list-sub">A photo of the installed Smart Home Panel 2 unit.</li>
                            </ul>
                            <div className="list-img">
                                <EFPicture
                                    src="/responsive/picture/delta-pro-ultra/launch/installation_fee.png"
                                    srcMobile="/responsive/picture/delta-pro-ultra/launch/installation_fee_M.png"
                                    alt={'Step 3 : Contact the Customer service team to reimburse the fee with the following claims：'}
                                />
                            </div>
                        </li>
                        <li className="list">
                            Step 4 : Upon verification of your claim, we’ll process a $500 refund of the total installation cost back to your original payment
                            method.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
